import { defineMessage } from "react-intl";
import type { FigureMetadata } from "../components/figure";
export const metadata: FigureMetadata = {
  id: "GPITREND",
  title: defineMessage({
    id: "fig.equity.GPITREND.title",
    defaultMessage: `Adjusted gender parity index for gross enrolment ratios by level`,
  }),
  caption: defineMessage({
    id: "fig.equity.GPITREND.caption",
    defaultMessage: `Progress towards gender parity varied by country`,
  }),
  source: defineMessage({
    id: "fig.equity.GPITREND.source",
    defaultMessage: `UIS database`,
  }),
};
